import type { LandingRoulettePrizeType, PublicRouletteDisplay, PublicRoulettePrize } from '@/lib/landing-roulette'

const POSITIONS_MIN = 2
const POSITIONS_MAX = 16
const PRIZE_TYPES: LandingRoulettePrizeType[] = ['coupon', 'lucky_number', 'pix', 'none']

function clampPositions(value: unknown): number {
  const parsed = typeof value === 'number' ? value : Number(value)
  if (!Number.isFinite(parsed)) {
    return POSITIONS_MIN
  }

  return Math.min(POSITIONS_MAX, Math.max(POSITIONS_MIN, Math.round(parsed)))
}

function isPrizeType(value: unknown): value is LandingRoulettePrizeType {
  return typeof value === 'string' && PRIZE_TYPES.includes(value as LandingRoulettePrizeType)
}

function normalizePrize(raw: unknown, maxPosition: number): PublicRoulettePrize | null {
  if (!raw || typeof raw !== 'object') {
    return null
  }

  const prize = raw as Partial<PublicRoulettePrize>
  const position = Number(prize.position)
  if (!Number.isInteger(position) || position < 1 || position > maxPosition) {
    return null
  }

  if (!isPrizeType(prize.prize_type)) {
    return null
  }

  const display =
    prize.display && typeof prize.display === 'object' && !Array.isArray(prize.display) ? prize.display : {}

  return {
    position,
    prize_type: prize.prize_type,
    display,
  }
}

/**
 * Garante `positions` (2–16) e `prizes` como array, para a roleta nunca quebrar no `.find`.
 */
export function normalizePublicRouletteDisplay(
  raw: Partial<PublicRouletteDisplay> | null | undefined
): PublicRouletteDisplay {
  const positions = clampPositions(raw?.positions)
  const source = Array.isArray(raw?.prizes) ? raw.prizes : []
  const prizes = source
    .map((prize) => normalizePrize(prize, positions))
    .filter((prize): prize is PublicRoulettePrize => prize !== null)

  return { positions, prizes }
}
